import axios from "axios";
import { AppDispatch } from "../store";
import { AccountInfo, IPublicClientApplication } from "@azure/msal-browser";
import { getApiUrl } from "../helpers/environmentHelper";
import { OrderType } from "../../models/responses/orderType";
import { setIsWaitingOrderPatchResponse, setIsWaitingOrderTypeGetResponse, setOrderType, setOrderTypeListForMenu } from "../slices/orderTypeSlice";
import { ClientType } from "../../models/enums/clientTypeEnum";
import { acquireApiToken } from "../helpers/apiTokenHelper";

export const getOrderTypes =
  (instance: IPublicClientApplication, account: AccountInfo | null, clientType: ClientType) =>
    async (dispatch: AppDispatch) => {
      const baseUrl = getApiUrl(window.location.hostname, 2);
      dispatch(setIsWaitingOrderTypeGetResponse(true));

      try {
        if (account) {
          acquireApiToken(instance, account)
            .then(async (response) => {
              if (response) {
                const getData: OrderType[] = (
                  await axios.get(`${baseUrl}/orderTypes?clientType=${clientType}`, {
                    timeout: 10000,
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: `Bearer ${response.accessToken}`,
                    },
                  })
                ).data;
                dispatch(setOrderTypeListForMenu({ orderTypeList: getData }));
                dispatch(setIsWaitingOrderTypeGetResponse(false));
              }
            });
        }
      } catch (error) {
        dispatch(setIsWaitingOrderTypeGetResponse(false));
        console.log(error);
      }
    };



export const getOrderTypeById =
  (
    instance: IPublicClientApplication,
    account: AccountInfo | null,
    id: string | undefined
  ) =>
    async (dispatch: AppDispatch) => {
      if (!id) return;
      const baseUrl = getApiUrl(window.location.hostname, 1);
      dispatch(setIsWaitingOrderTypeGetResponse(true));

      try {
        if (account) {
          acquireApiToken(instance, account)
            .then(async (response) => {
              if (response) {
                const getData: OrderType = (
                  await axios.get(`${baseUrl}/orderTypes/${id}`, {
                    timeout: 10000,
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: `Bearer ${response.accessToken}`,
                    },
                  })
                ).data;
                dispatch(setOrderType({ orderType: getData }));
                dispatch(setIsWaitingOrderTypeGetResponse(false));
              }
            });
        }
      } catch (error) {
        dispatch(setIsWaitingOrderTypeGetResponse(false));
        console.log(error);
      }
    };

export const putOrderType =
  (instance: IPublicClientApplication, account: AccountInfo | null, orderType: OrderType) =>
    async (dispatch: AppDispatch) => {
      const baseUrl = getApiUrl(window.location.hostname, 2);
      dispatch(setIsWaitingOrderPatchResponse(true));

      try {
        if (account) {
          acquireApiToken(instance, account)
            .then(async (response) => {
              if (response) {
                await axios.put(`${baseUrl}/orderTypes`, orderType, {
                  timeout: 10000,
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${response.accessToken}`,
                  },
                });
                dispatch(setIsWaitingOrderPatchResponse(false));
              }
            });
        }
      } catch (error) {
        dispatch(setIsWaitingOrderPatchResponse(false));
        console.log(error);
      }
    };
